import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/headers/AppHeader.jsx';
import Schedule from './components/SheduleFull/ScheduleFull.jsx';
import TeacherScheduleСhoose from './components/TeacherSchedule/TeacherScheduleСhoose.jsx';
import TeacherScheduleDetail from './components/TeacherSchedule/TeacherScheduleDetail.jsx';
import ClassroomScheduleChoose from './components/ClassroomSchedule/ClassRoomScheduleChoose.jsx';
import ClassRoomScheduleDetail from './components/ClassroomSchedule/ClassRoomScheduleDetail.jsx';
import GroupScheduleChoose from './components/GroupSchedule/GroupScheduleChoose.jsx';
import GroupScheduleDetail from './components/GroupSchedule/GroupScheduleDetail.jsx';
import ExamSchedule from './components/ExamSchedule/ExamSchedule.jsx';
import Archive from './components/Archive/Archive.jsx';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Schedule />} />
          <Route path="/teachers" element={<TeacherScheduleСhoose />} />
          <Route path="/teachers/:teacherName" element={<TeacherScheduleDetail />} />
          <Route path="/classroom" element={<ClassroomScheduleChoose />} />
          <Route path="/classroom/:classroomName" element={<ClassRoomScheduleDetail />} />
          <Route path="/students" element={<GroupScheduleChoose />} />
          <Route path="/students/:groupName" element={<GroupScheduleDetail />} />
          <Route path="/exams" element={<ExamSchedule />} />
          <Route path="/archive" element={<Archive />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;